/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
$( document ).ready(function() {
  var page_load_tab = localStorage.getItem('page_load_tab');
  var page_load_val = localStorage.getItem('page_load_val');
  var page_load_val_int = parseInt(page_load_val);
  console.log(page_load_val_int);
  if (page_load_val_int === 1){
    console.log('matched');
    $(page_load_tab).trigger( "click" );
    localStorage.setItem('page_load_val', '0');
  }
  
  $(".tr_target_link_nindex").click(function(){
    var target_tab = $(this).data("target");
    localStorage.setItem('page_load_tab', target_tab);
    localStorage.setItem('page_load_val', '1');
    $('html, body').animate({
      scrollTop: $($.attr(this, 'href')).offset().top - 100
    }, 200);
  });
  
  var default_variant = localStorage.getItem('default_select_var');
  console.log(default_variant);
  $('#'+default_variant).trigger( "click" );
  $(".tr_target_link").click(function(){
    event.preventDefault();
    var target_tab = $(this).data("target");
    $(target_tab).trigger( "click" );
    $('.Drawer__Close.Icon-Wrapper--clickable').trigger( "click" );
    $('html, body').animate({
      scrollTop: $($.attr(this, 'href')).offset().top - 60
    }, 200);
  });

});